import { render } from "./CenteredText.vue?vue&type=template&id=87a0dc48"
import script from "./CenteredText.vue?vue&type=script&lang=ts"
export * from "./CenteredText.vue?vue&type=script&lang=ts"
script.render = render

export default script